import { useMemo } from 'react';
import { useUserModules } from '../api';
import { ComposeWizard } from '../components/ComposeWizard';

export function AddVoiceCampaignPage() {
  const modules = useUserModules();

  const moduleNames = useMemo(
    () => new Set((modules.data ?? []).map((m) => m.moduleName)),
    [modules.data],
  );

  const isContinuous = moduleNames.has('Continuous Campaign');

  return (
    <ComposeWizard
      mode="create"
      pageTitle={'Compose Campaign'}
      pageDescription={
        isContinuous
          ? 'Build a new continuous outbound voice campaign in six steps.'
          : 'Build a new outbound voice campaign in six steps.'
      }
    />
  );
}
